import { APP_CONFIG } from '../../config';
import { get } from '../request';
import { valuationsToApp } from './converters/valuation';

export const getValuations = async (): Promise<{ valuationsCount: number }> => {
  return valuationsToApp(await get(`${APP_CONFIG.apiEndpoint}/valuations/my?pageSize=1&page=0`));
};
